import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Label, Row} from "reactstrap"
import Switch from "react-bootstrap-switch";

// components
import Separator from "../../../components/Separator";
import ModalFormTitle from "../../../components/genericComponents/ModalFormTitle";
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

// labels
import {LB_NAME} from "../../../components/i18n/i18n"
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// services
import {classConfigurationService} from "../../../jwt/_services/configuration/classConfigurationService"

// utils
import {getStateByPath} from "../../../redux/selectors";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {mainProvider} from "../../../providers/mainProvider";
import SelectGeneric from "../../../components/select/selectGeneric";



const ClassConfigurationForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { udn, app, editMode, domainObject} = componentState?.data;

    const {fbDataBase} = app

    const [className, setClassName] = useState(domainObject?.className || null);
    const [realTime, setRealTime] = useState(domainObject?.realTime || null);
    const [firestore, setFirestore] = useState(domainObject?.firestore || null);
    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({});

    const { handleSubmit, reset } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
            }
        };

        if(className !== undefined && className !== null)
            dataRequest.item.className = className;

        if(realTime !== undefined && realTime !== null)
            dataRequest.item.realTime = realTime;

        if(firestore !== undefined && firestore !== null)
            dataRequest.item.firestore = firestore;


        if (!editMode)
            genericIndexedActions.save(path, classConfigurationService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, classConfigurationService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        setClassName(null)
        setRealTime(null)
        setFirestore(null)
        reset();
        props.onClose()
    }


    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <ModalFormTitle
                    domainObject={domainObject}
                    editMode={editMode}
                    udn={udn}
                />

                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{LB_NAME}</Label>
                            <SelectGeneric
                                initialValue={ className }
                                setExternalValue={ setClassName }
                                provider={ mainProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Realtime'}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={realTime}
                                onChange={ () => setRealTime(!realTime) }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Firestore'}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={firestore}
                                onChange={ () => setFirestore(!firestore) }
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}
export default ClassConfigurationForm